import React from "react";
import StayTouch from "../../layout/StayTouch";
import AnyQuestions from "../../reusable/AnyQuestions";
import TopBanner from "../../reusable/TopBanner";
import GetSimSubNavi from "../../reusable/GetSimSubNavi";
import ActiveSimRequestController from "./ActiveSimRequestController";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import { connect } from "react-redux";


class ActiveSim extends React.Component {
    render(){
        const { isAuthenticated, user } = this.props.auth;
        return(
            <div>
                <TopBanner title="Activate SIM"/>
                {/*<GetSimSubNavi />*/}
                <ActiveSimRequestController isAuthenticated={isAuthenticated} user={user} />
                <AnyQuestions />
                <StayTouch />
            </div>
        );
    }
}

function mapStateToProps(state) {
    if(!state.auth.isAuthenticated) {
        state.auth.redirect = "/activate/sim";
    }
    return {
        auth: state.auth
    };
}
export default connect(mapStateToProps)(layoutWrapper(ActiveSim));



// WEBPACK FOOTER //
// ./src/pages/ActiveSim/index.js